var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',[_c('tr',[_c('td',[_c('v-checkbox',{attrs:{"color":"success","value":_vm.c,"hide-details":""},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}})],1)]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('strong',[_vm._v("C")])]),_c('td',[_c('strong',[_vm._v("NC")])]),_c('td',[_c('strong',[_vm._v("NA")])])])
}]

export { render, staticRenderFns }